/**
 * Service for generating image URLs and srcsets
 */

/**
 * Generate the appropriate image URL for a given image path and layout
 * @param {string} imagePath - The base image path
 * @param {boolean} isTwoColumnLayout - Whether using two-column layout
 * @returns {string} - The formatted image URL
 */
export function getImageUrl(imagePath, isTwoColumnLayout) {
    if (!imagePath) return '';

    return isTwoColumnLayout
        ? `${imagePath}-/resize/600x/-/format/auto/`
        : `${imagePath}-/resize/550x/-/format/auto/`;
}

/**
 * Generate the appropriate srcset for a given image path and layout
 * @param {string} imagePath - The base image path
 * @param {boolean} isTwoColumnLayout - Whether using two-column layout
 * @returns {string} - The formatted srcset string
 */
export function getImageSrcset(imagePath, isTwoColumnLayout) {
    if (!imagePath) return '';

    return isTwoColumnLayout
        ? `${imagePath}-/resize/600x/-/format/auto/ 1x,
       ${imagePath}-/resize/1200x/-/format/auto/ 2x,
       ${imagePath}-/resize/1800x/-/format/auto/ 3x`
        : `${imagePath}-/resize/550x/-/format/auto/ 1x,
       ${imagePath}-/resize/1100x/-/format/auto/ 2x,
       ${imagePath}-/resize/1650x/-/format/auto/ 3x`;
}

/**
 * Generate the video thumbnail URL
 * @param {string} videoId - The Mux video ID
 * @returns {string} - The formatted thumbnail URL
 */
export function getVideoThumbnailUrl(videoId) {
    if (!videoId) return '';

    return `https://image.mux.com/${videoId}/thumbnail.jpg?time=0&width=1100`;
}
